import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { navTimingValues } from '../../../common/timing/nav-timing';
import { Interaction } from './interaction';
import { numeric } from '../../../common/serialize/bel-serializer';
import { firstPaint } from '../../../common/vitals/first-paint';
import { firstContentfulPaint } from '../../../common/vitals/first-contentful-paint';
import { getInfo } from '../../../common/config/info';
export var InitialPageLoadInteraction = /*#__PURE__*/function (_Interaction) {
  _inherits(InitialPageLoadInteraction, _Interaction);

  var _super = _createSuper(InitialPageLoadInteraction);

  function InitialPageLoadInteraction(agentIdentifier) {
    var _this;

    _classCallCheck(this, InitialPageLoadInteraction);

    _this = _super.call(this, agentIdentifier, 'initialPageLoad', 0, null);
    var agentInfo = getInfo(agentIdentifier);
    _this.queueTime = agentInfo.queueTime;
    _this.appTime = agentInfo.applicationTime;
    return _this;
  }

  _createClass(InitialPageLoadInteraction, [{
    key: "firstPaint",
    get: function get() {
      return firstPaint.current.value;
    }
  }, {
    key: "firstContentfulPaint",
    get: function get() {
      return firstContentfulPaint.current.value;
    }
    /**
     * Build the navTiming node. This assumes the navTimingValues array in nav-timing.js has already been filled with values via the PageViewEvent feature having
     * executed the addPT function first and foremost.
     */

  }, {
    key: "navTiming",
    get: function get() {
      if (!navTimingValues.length) return;
      /*
      1. we initialize the seperator to ',' (seperates the nodeType id from the first value)
      2. we initialize the navTiming node to 'b' (the nodeType id)
      3. if the value is present, we add the seperator followed by the value;
         otherwise:
          - we add null seperator ('!') to the navTimingNode
          - we set the seperator to an empty string since we already wrote it above
        the reason for writing the null seperator instead of setting the seperator
        is to ensure we still write it if the null is the last navTiming value.
      */

      var seperator = ',';
      var navTimingNode = 'b';
      var prev = 0; // Get all navTiming values except offset aka timeOrigin since we just consider that (this.start) 0.
      // These are the latter 20 of the 21 timings appended by addPT:

      navTimingValues.slice(1, 21).forEach(function (v) {
        if (v !== undefined) {
          navTimingNode += seperator + numeric(v - prev);
          seperator = ',';
          prev = v;
        } else {
          navTimingNode += seperator + '!';
          seperator = '';
        }
      });
      return navTimingNode;
    }
  }]);

  return InitialPageLoadInteraction;
}(Interaction);